import { render, staticRenderFns } from "./UploadPatientMedicalReport.vue?vue&type=template&id=3902ce30"
import script from "./UploadPatientMedicalReport.vue?vue&type=script&lang=js"
export * from "./UploadPatientMedicalReport.vue?vue&type=script&lang=js"
import style0 from "./UploadPatientMedicalReport.vue?vue&type=style&index=0&id=3902ce30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports